// Dependencies
import React from 'react'

// Components
import { SolicitudViolenciaSectionContainer } from './GeneralMicroComponents/SolicitudViolenciaSectionContainer'
import { InputGroup } from '../../../ui/InputGroup'

//Mocks de los inputs de la segunda parte del formulario
import { SecondPartInputs } from './inputsDataMock'
import { Grid } from '@mui/material'

const SecondFormSectionSolicitudViolencia = () => {
  return (
    <SolicitudViolenciaSectionContainer>
      <p className='heading-title__background card-content p-3 mb-4'>2.- Datos presunto generador de violencia</p>

      <div className='w-full m-auto p-3'>  
        <InputGroup itemData={SecondPartInputs[0]} />

        <Grid container spacing={2} className='m-auto w-full p-4'>
          {[...SecondPartInputs.slice(1,4).map((item, index) => (
            <InputGroup itemData={item} key={index} />
          ))]}
        </Grid>
        
        <InputGroup itemData={SecondPartInputs[SecondPartInputs.length - 1]} col="col-full" />

      </div>
    </SolicitudViolenciaSectionContainer> 
  )
}

export {SecondFormSectionSolicitudViolencia}